const styles = {
	wrapper: {
		a: {
			color: 'primary',
			display: 'flex',
			flexDirection: 'column',
			textDecoration: 'none',
		},
		'&:hover': {
			'.gatsby-image-wrapper': {
				transform: 'scale(1.1)',
			},
			figcaption: {
				background:
					'linear-gradient(to top, rgba(0, 0, 0, 0.1) , rgba(0, 0, 0, 0))',
				h3: {
					bottom: 'calc(50% - 20px)',
				},
				'.textBtn': {
					opacity: 1,
					visibility: 'visible',
				},
			},
		},
	},
	figure: {
		display: 'flex',
		height: [150, 180],		
		flexDirection: 'row',
		alignItems: 'center',
		textAlign: 'center',
		position: 'relative',
		borderRadius: 6,
		overflow: 'hidden',
		'.gatsby-image-wrapper': {
			width: [40, 50],
			height: [40, 50],
			margin: 10,
			position: 'relative',
			overflow: 'hidden',
			borderRadius: 6,
			img: {
				width: '100%',
				height: '100%',
				objectFit: 'cover',
			},
		},
		border: '2px solid',
        borderColor: 'muted',
	},
	figcaption: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: ['center', 'flex-end'],
		padding: [20, 30],
		position: 'absolute',
		left: 0,
		bottom: 0,
		width: '100%',
		height: '100%',
		background: [
			'linear-gradient(to top, rgba(0, 0, 0, 0.2) , rgba(0, 0, 0, 0))',
			'linear-gradient(to top, rgba(0, 0, 0, 0.2) , rgba(0, 0, 0, 0))',
		],
		h3: {
			fontSize: ['17px', 2],
			fontWeight: '600',
			position: 'absolute',
			width: 'calc(100% - 60px)',
			bottom: ['calc(50% - 17px)', 30],
			transition: 'bottom 0.25s ease-out',
		},
	},
	textBtn: {
		opacity: 0,
		visibility: 'hidden',
		position: 'absolute',
		bottom: 30,
		fontWeight: '700',
		textTransform: 'capitalize',
		width: 'calc(100% - 60px)',
		display: ['none', 'flex'],
		alignItems: 'center',
		justifyContent: 'center',
		transition: 'opacity 0.2s ease',
		svg: {
			width: 20,
			height: 'auto',
			marginLeft: 10,
			position: 'relative',
			marginTop: 1,
		},
	},
};

export default styles;
